import * as React from 'react';

export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="78" height="58" fill="none">
    <path
      stroke="#0067F4"
      strokeWidth="4"
      d="m14.5 15 7.563 2.786A32 32 0 0 1 43 47.813V58M14.5 15l4 10m-4-10 10-4"
    />
    <path
      stroke="#0067F4"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M44.5 8V6h10v2"
    />
    <path stroke="#0067F4" strokeLinecap="round" strokeWidth="2" d="M47.5 18h4" />
    <path stroke="#0067F4" strokeWidth="2" d="M49.5 18V6" />
    <path
      stroke="#0067F4"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M6.5 42h12M6.5 48h12M9.5 51V39M15.5 51V39"
    />
    <path
      fill="#0067F4"
      fillRule="evenodd"
      d="M57.5 47a1 1 0 0 0 1 1h14a1 1 0 1 0 0-2h-13V33a1 1 0 1 0-2 0v14Zm15.578-12.816a1 1 0 0 1 .238 1.394l-4.783 6.75a1 1 0 0 1-1.578.07l-1.963-2.31-2.633 4.423a1 1 0 1 1-1.718-1.022l3.348-5.625a1 1 0 0 1 1.62-.137l2.037 2.395 4.038-5.7a1 1 0 0 1 1.394-.238Z"
      clipRule="evenodd"
    />
  </svg>
);
